import * as React from 'react'
import { memo } from 'react'
const SvgArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 4 5.85"
  >
    <path d="M4 3.15a9.521 9.521 0 0 0-3.162 2.7H0a13.525 13.525 0 0 1 .719-1.4 10.325 10.325 0 0 1 1.143-1.529C1.576 2.535.942 1.775.719 1.375A14.822 14.822 0 0 1 0 0h.838A9.927 9.927 0 0 0 4 2.7Z" />
  </svg>
)
const Memo = memo(SvgArrowRight)
export default Memo
